import React from "react";

import { useStore } from "src/store";

import Context from "./Context";

const AdBlockDetector = () => {
  const store = useStore("config");
  const { template = {} } = store("config");
  const { detectAdBlockers = false } = template;

  let adBlockDetector = null;
  let didInit = false;

  const initAdBlockDetector = () => {
    import(/* webpackChunkName: "blockadblock" */ "blockadblock/blockadblock.js").then(() => {
      adBlockDetector = window.blockAdBlock;

      const reportGAEvent = (category = "Ads", adUnitId) => {
        if (window.gtag) {
          window.gtag("send", "event", {
            event_category: category,
            event_action: "Blocked",
            event_label: adUnitId,
            transport: "beacon"
          });
        }
      };

      const isAdBlockDetected = cb => {
        let didCheck = false;
        let isDetected = false;

        if (didCheck) {
          cb(isDetected);
          return;
        }

        adBlockDetector.check();

        adBlockDetector.onDetected(() => {
          didCheck = true;
          isDetected = true;
          cb(isDetected);
          return;
        });

        adBlockDetector.onNotDetected(() => {
          didCheck = true;
          isDetected = false;
          cb(isDetected);
          return;
        });
      };

      if (window.googletag) {
        window.googletag.cmd.push(() => {
          window.googletag.pubads().addEventListener("slotRequested", event => {
            isAdBlockDetected(detected => {
              if (detected) {
                let adUnitId = "";

                if (event && event.slot) {
                  adUnitId = event.slot.getSlotId().getId();
                }

                reportGAEvent("Ads", adUnitId);
              }
            });
          });
        });
      }

      isAdBlockDetected(detected => {
        if (detected) {
          reportGAEvent("extAds", "Unknown");
        }
      });
    });
  };

  return (
    <Context.Consumer>
      {({ loaded }) => {
        if (loaded && !adBlockDetector && detectAdBlockers && !didInit) {
          didInit = true;
          initAdBlockDetector();
        }
      }}
    </Context.Consumer>
  );
};

export default AdBlockDetector;
